/*
 * Le fichier est encapsule dans une IIFE et l'enregistrement est garde.
 *
 * sections/image-banner.liquid charge ce script a chaque instance de la
 * section. Deux bannieres sur la meme page (cas de templates/page.cms.json)
 * produisaient donc deux balises <script> identiques, et la seconde levait
 * « Identifier 'ImageBanner' has already been declared ».
 *
 * Un simple garde sur customElements.define ne suffit pas : une classe
 * declaree au niveau racine d'un script classique cree une liaison dans la
 * portee lexicale globale, et l'erreur est levee a l'analyse du second
 * script, avant que le moindre garde ne puisse s'executer. Il faut donc
 * sortir la declaration de la portee globale.
 */
(() => {
	if (customElements.get('image-banner')) return;

	class ImageBanner extends HTMLElement {
		constructor() {
			super();
			this.videoElement = this.querySelector('video');
			this.desktopSrc = this.videoElement?.getAttribute('data-src');
			this.mobileSrc = this.videoElement?.getAttribute('data-mobile-src');
			// Reference stable : bind() renvoie une nouvelle fonction a chaque
			// appel, donc removeEventListener ne retirait jamais l'ecouteur.
			this.onResize = this.updateVideoSource.bind(this);
		}

		connectedCallback() {
			this.updateVideoSource();
			window.addEventListener('resize', this.onResize);
		}

		disconnectedCallback() {
			window.removeEventListener('resize', this.onResize);
		}

		updateVideoSource() {
			const isMobile = window.matchMedia('(max-width: 749px)').matches;

			if (this.videoElement) {
				const currentSrc = this.videoElement.getAttribute('src');
				const newSrc = isMobile ? this.mobileSrc : this.desktopSrc;

				if (currentSrc !== newSrc) {
					this.videoElement.setAttribute('src', newSrc);
					this.videoElement.load();
				}
			}
		}
	}

	customElements.define('image-banner', ImageBanner);
})();
